export enum ScoreType {
  SAT = 'SAT',
  Math = 'Math',
  EBRW = 'EBRW',
}
